import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

/**
 * The confident surface: an aubergine (tenant primary) card carrying light
 * text — next appointment, balance due, membership. Content inside uses the
 * `inverse` / `inverse-variant` colours and `inverse` buttons.
 */
export function HeroCard({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cx('bg-surface-high text-inverse rounded-xl p-6 shadow-lg', className)} {...rest}>
      {children}
    </div>
  );
}

export function HeroEyebrow({ children }: { children: ReactNode }) {
  return <p className="text-eyebrow uppercase font-semibold text-inverse-variant tracking-widest rtl:tracking-normal">{children}</p>;
}

export function HeroTitle({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cx('font-serif text-display text-inverse mt-2', className)}>{children}</p>;
}

export function HeroText({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cx('text-body text-inverse-variant', className)}>{children}</p>;
}

export function HeroDivider() {
  return <hr className="border-0 border-t border-inverse-hairline my-4" />;
}
